/* eslint-disable react/no-array-index-key */
import { Box, Icon, Text } from "@quintoandar-tokko/jopijs";
import { useSelector } from "react-redux";
import style from "../fichaInfo.module.scss";
import Skeleton from "../skelenton/Skeleton";

export default function Atributes() {
  const { origin_data, isEdition, loading } = useSelector(
    (state) => state.FichaInfoSlice
  );

  if (loading)
    return (
      <Box
        __css={{
          display: "flex",
          gap: "48px",
          alignItems: "center",
        }}
      >
        {Array(5)
          .fill()
          .map((arr, i) => (
            <Box
              key={`${i} + 100`}
              __css={{
                display: "flex",
                width: "128px",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Skeleton width={16} borderRadius={4} height={16} />
              <Skeleton width={53} borderRadius={50} height={8} />
            </Box>
          ))}
      </Box>
    );

  return origin_data.attributes_list?.length > 0 ? (
    <Box
      className={`${style.atrubutesContainer} ${
        isEdition ? style.opacity : ""
      }`}
    >
      {origin_data.attributes_list.map((item, index) => (
        <Box key={index} className={style.atrubutesItem}>
          <Icon icon={item.icon} fontSize="16px" />
          <Text variant="bodyBold.fontSize12">{item.value}</Text>
        </Box>
      ))}
    </Box>
  ) : null;
}
